// @ts-nocheck
import returnRequestReducer, {
    StoreReturnRequestActions,
} from "@store/Framework/Store/Store/Pages/ReturnRequest/ReturnRequestReducer";
import returnSlipReducer, {
    StoreReturnSlipActions,
} from "@store/Framework/Store/Store/Pages/ReturnSlip/ReturnSlipReducer";
import { combineReducers } from "redux";
import backOrdersReducer, { BackOrdersActions } from "@store/Framework/Store/Store/Pages/BackOrders/BackOrdersReducer";

const pagesReducers = {
    backOrders: backOrdersReducer,
    returnRequest: returnRequestReducer,
    returnSlip: returnSlipReducer,
};

export type StorePagesActions = StoreReturnRequestActions | StoreReturnSlipActions | BackOrdersActions;
export default combineReducers(pagesReducers);
